import { render, staticRenderFns } from "./bookingWorkspace.vue?vue&type=template&id=08411a16&scoped=true&"
import script from "./bookingWorkspace.vue?vue&type=script&lang=js&"
export * from "./bookingWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./bookingWorkspace.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bookingWorkspace.vue?vue&type=style&index=1&id=08411a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08411a16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08411a16')) {
      api.createRecord('08411a16', component.options)
    } else {
      api.reload('08411a16', component.options)
    }
    module.hot.accept("./bookingWorkspace.vue?vue&type=template&id=08411a16&scoped=true&", function () {
      api.rerender('08411a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/bookingWorkspace.vue"
export default component.exports